import i18n from '../i18n'

const BASE_URL = 'https://www.vocalise.app'

function getLegalLocale(): 'en' | 'sv-se' {
  const lang = (i18n.language ?? i18n.resolvedLanguage ?? 'en').toLowerCase()
  return lang.startsWith('sv') ? 'sv-se' : 'en'
}

export function getPrivacyPolicyUrl(): string {
  const locale = getLegalLocale()
  return `${BASE_URL}/${locale}/privacy-policy`
}

export function getTermsUrl(): string {
  const locale = getLegalLocale()
  return `${BASE_URL}/${locale}/terms-of-service`
}
